<template>
  <span class="custom-select-option-list">
    <span v-if="$slots.header" class="custom-select-option-list__header">
      <slot name="header"></slot>
    </span>
    <span class="custom-select-option-list__body">
      <span
        v-for="(option, index) in options"
        :key="getOptionId(index)"
        class="custom-select-option-list__item"
      >
        <input
          :id="getOptionId(index)"
          v-model="localValue"
          :type="inputType"
          :name="name"
          :value="getOptionValue(option)"
          :disabled="disabled"
          class="custom-select-option-list__item-input"
        />

        <label
          :for="getOptionId(index)"
          :class="{
            'custom-select-option-list__item-label--default':
              !$scopedSlots.default,
          }"
          class="custom-select-option-list__item-label"
          :title="getOptionLabel(option)"
        >
          <slot v-bind="{ option, getOptionLabel }">
            {{ getOptionLabel(option) }}
          </slot>
        </label>
      </span>
    </span>
    <span v-if="$slots.footer" class="custom-select-option-list__footer">
      <slot name="footer"></slot>
    </span>
  </span>
</template>

<script>
import SelectOptionList from '../mixins/SelectOptionList';
import { randomStr } from '../utils/String';
import SelectOptionProps from '../mixins/SelectOptionProps';

const CheckableInputType = Object.freeze({
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
});

export default {
  name: 'CustomSelectOptionList',
  mixins: [SelectOptionList, SelectOptionProps],
  props: {
    id: {
      type: String,
      default: () => randomStr(),
    },
  },
  computed: {
    inputType() {
      return this.multiple
        ? CheckableInputType.CHECKBOX
        : CheckableInputType.RADIO;
    },
    localValue: {
      get() {
        if (this.value) {
          return this.value;
        }

        if (this.multiple) {
          return [];
        }

        return null;
      },
      set(v) {
        this.$emit('change', v);
      },
    },
  },
  methods: {
    getOptionId(index) {
      return `custom-select-option-list__item-input--${this.name}--${this.id}--${index}`;
    },
  },
};
</script>

<style lang="scss" scoped>
$custom-select-option-list-item-label-default-padding: 0 0.5em !default;

.custom-select-option-list {
  display: block;

  &__item {
    display: flex;
  }

  &__item-input {
    @include sr-only();
  }

  &__item-label {
    flex: 1;
    min-width: 0;
    cursor: pointer;

    &--default {
      user-select: none;
      padding: $custom-select-option-list-item-label-default-padding;
    }
  }
}
</style>
